/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Drop_Files_HereInputs */

const en_common_drop_files_here = /** @type {(inputs: Common_Drop_Files_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop your files here`)
};

const es_common_drop_files_here = /** @type {(inputs: Common_Drop_Files_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta tus archivos aquí`)
};

/**
* | output |
* | --- |
* | "Drop your files here" |
*
* @param {Common_Drop_Files_HereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_drop_files_here = /** @type {((inputs?: Common_Drop_Files_HereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Drop_Files_HereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_drop_files_here(inputs)
	return en_common_drop_files_here(inputs)
});